import { useState } from "react";
import { Users, CalendarDays, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/lib/content";
import LeadsTable from "@/components/admin/LeadsTable";
import BatchManager from "@/components/admin/BatchManager";

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("leads");

  const tabs = [
    { key: "leads", label: "Leads", icon: Users },
    { key: "batches", label: "Batches", icon: CalendarDays },
  ];

  return (
    <div className="min-h-screen bg-slate-50" data-testid="admin-dashboard">
      {/* top bar */}
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8">
          <div className="flex items-center gap-2.5">
            <img src={BRAND.logo} alt="BullsEdge" className="h-9 w-9 rounded-lg object-contain" />
            <div className="leading-none">
              <p className="font-display text-lg font-bold text-slate-900">BullsEdge CRM</p>
              <p className="text-[0.62rem] font-semibold uppercase tracking-[0.18em] text-emerald-600">
                Ahmedabad Center
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-slate-500 sm:inline">{user?.email}</span>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="flex min-h-[40px] items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 transition-colors hover:border-red-300 hover:text-red-600"
            >
              <LogOut size={15} /> Logout
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-8">
        <h1 className="font-display text-4xl font-bold uppercase text-slate-900">
          {tab === "leads" ? "Leads & Follow-ups" : "Batch Management"}
        </h1>

        {/* tabs */}
        <div className="mt-5 inline-flex rounded-xl border border-slate-200 bg-white p-1">
          {tabs.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              data-testid={`tab-${key}`}
              className={`flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${
                tab === key
                  ? "bg-emerald-brand text-white"
                  : "text-slate-600 hover:text-slate-900"
              }`}
            >
              <Icon size={16} /> {label}
            </button>
          ))}
        </div>

        <div className="mt-6">
          {tab === "leads" ? <LeadsTable /> : <BatchManager />}
        </div>
      </main>
    </div>
  );
}
